module.exports = __webpack_public_path__ + "static/media/Tova Safra.416dd9c9.png";